// Hand-maintained. `./bin/rails stimulus:manifest:update` would rewrite this file
// and reach past the namespace barrels below, so a new controller is registered
// here by hand.
//
// A controller in a namespace lives at controllers/<namespace>/<…>/name_controller.js
// and registers under the path with `--` for each separator:
// admin/sidebar/scroll_controller.js → "admin--sidebar--scroll". Each namespace
// directory carries an index.js that re-exports what is under it, so this file
// imports the namespace once rather than a line per controller.
//
// Only what the public pages use is registered here. The admin's controllers
// (and the admin/ namespace) register in app/javascript/admin.js, a bundle of
// its own that only the admin layout loads.

import { application } from "./application";

import header from "./header";

import AutocompleteController from "./autocomplete_controller";
import CarouselController from "./carousel_controller";
import ClipboardController from "./clipboard_controller";
import ClockController from "./clock_controller";
import DropdownController from "./dropdown_controller";
import FavoriteController from "./favorite_controller";
import LightboxController from "./lightbox_controller";
import MapController from "./map_controller";
import ModalController from "./modal_controller";
import OpeningHoursController from "./opening_hours_controller";
import RemoveController from "./remove_controller";
import SectionNavController from "./section_nav_controller";
import ShareController from "./share_controller";
import TooltipController from "./tooltip_controller";

application.register("autocomplete", AutocompleteController);
application.register("carousel", CarouselController);
application.register("clipboard", ClipboardController);
application.register("clock", ClockController);
application.register("dropdown", DropdownController);
application.register("favorite", FavoriteController);
application.register("header--sticky", header.StickyController);
application.register("lightbox", LightboxController);
application.register("map", MapController);
application.register("modal", ModalController);
application.register("opening-hours", OpeningHoursController);
application.register("remove", RemoveController);
application.register("section-nav", SectionNavController);
application.register("share", ShareController);
application.register("tooltip", TooltipController);
